"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.kill = exports.updateAll = exports.setValue = exports.moveTo = exports.create = exports.getAll = void 0;
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var common_1 = require("@main/common");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var spritesUtil_sidecar_1 = require("@sprites/spritesUtil-sidecar");
var voyageLayers_sidecar_1 = require("@voyage/scene/voyageLayers-sidecar");
var objs = [];
function getAll() {
    return objs;
}
exports.getAll = getAll;
function create() {
    // underPerf.recordCreate('need-bars')
    var id = common_1.createId();
    var imageBack = spritesUtil_sidecar_1.spritesUtil.createImage(voyageLayers_sidecar_1.voyageLayers.getLayers().uiOnCam, sprites_sidecar_1.sprites.voyProgress2[0]);
    var image = spritesUtil_sidecar_1.spritesUtil.createImage(voyageLayers_sidecar_1.voyageLayers.getLayers().uiOnCam, sprites_sidecar_1.sprites.voyProgress1[0]);
    var obj = {
        eType: 'voy-misc',
        id: id,
        idLoaded: 0,
        isDead: false,
        image: image,
        imageBack: imageBack,
    };
    objs.push(obj);
    return obj;
}
exports.create = create;
function moveTo(obj, x, y) {
    obj.imageBack.x = x;
    obj.imageBack.y = y;
    obj.image.x = x;
    obj.image.y = y;
}
exports.moveTo = moveTo;
function setValue(obj, val) {
    if (val < 0) {
        val = 0;
    }
    if (val > 1) {
        val = 1;
    }
    // if (val < 0.33) {
    //   spritesUtil.setPackedFrame(obj.image, sprites.underNeedBar[1])
    // } else if (val < 0.66) {
    //   spritesUtil.setPackedFrame(obj.image, sprites.underNeedBar[2])
    // } else {
    //   spritesUtil.setPackedFrame(obj.image, sprites.underNeedBar[3])
    // }
    obj.image.visible = val > 0;
    obj.imageBack.visible = obj.image.visible;
    obj.image.scaleX = val * obj.imageBack.scaleX;
    obj.image.x =
        obj.imageBack.x -
            (obj.imageBack.width / 2) * (obj.imageBack.scaleX - obj.image.scaleX);
}
exports.setValue = setValue;
function updateAll() {
    // l.forEach(objs, (c) => {
    //   update(c)
    // })
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(objs, function (c) {
        c.image.destroy();
        c.imageBack.destroy();
    });
}
exports.updateAll = updateAll;
//export function update(obj: IVoyageProgressBar) {}
function kill(obj) {
    obj.isDead = true;
}
exports.kill = kill;
